"use client";

import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  SearchBox,
  Typography,
  Pagination,
} from "@repo/ui";
import { useState } from "react";
import Section from "../components/Section";
import Queries from "./Queries";

export default function CaseStudy() {
  const [currentPage, setCurrentPage] = useState(1);
  const totalItems = 100;
  const itemsPerPage = 10;

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  return (
    <>
      <Section>
        <Box flex justifyContent="between" className="mb-4">
          <Typography variant="h1">Case Studies by Spoclearn</Typography>
          <Box>
            <SearchBox />
          </Box>
        </Box>
        <Grid spacing={2} container className="pt-4">
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <Card>
              <CardMedia className="h-1/2" src="/images/webinar/author.jpg" />
              <CardContent className="gap-x-10 items-center">
                <Typography variant="h4">
                  Simple card with card content.
                </Typography>
                <Typography paragraph className="pt-2 text-gray-500">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo
                  ipsum accusamus iusto porro, error, ab iure id modi
                  reprehenderit doloribus voluptatibus quos eius magnam
                  aspernatur laborum eligendi sunt incidunt ratione.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <Card>
              <CardMedia className="h-1/2" src="/images/webinar/author.jpg" />
              <CardContent className="gap-x-10 items-center">
                <Typography variant="h4">
                  Simple card with card content.
                </Typography>
                <Typography paragraph className="pt-2 text-gray-500">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo
                  ipsum accusamus iusto porro, error, ab iure id modi
                  reprehenderit doloribus voluptatibus quos eius magnam
                  aspernatur laborum eligendi sunt incidunt ratione.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <Card>
              <CardMedia className="h-1/2" src="/images/webinar/author.jpg" />
              <CardContent className="gap-x-10 items-center">
                <Typography variant="h4">
                  Simple card with card content.
                </Typography>
                <Typography paragraph className="pt-2 text-gray-500">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo
                  ipsum accusamus iusto porro, error, ab iure id modi
                  reprehenderit doloribus voluptatibus quos eius magnam
                  aspernatur laborum eligendi sunt incidunt ratione.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Box
          flex
          justifyContent="between"
          alignItems="center"
          className="my-8 "
        >
          <Typography>Showing 5 out of 14 entities</Typography>
          <Box>
            <Pagination
              count={totalItems}
              itemsPerPage={itemsPerPage}
              page={currentPage}
              onPageChange={handlePageChange}
            />
          </Box>
        </Box>
      </Section>
      <Section className="bg-gradient-to-b from-purple-50 to-white">
        <Queries sectionInfo={{}} />
      </Section>
    </>
  );
}
